var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokTapConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9393 28.0607C13.3536 27.4749 13.3536 26.5251 13.9393 25.9393L17.9393 21.9393C18.5251 21.3536 19.4749 21.3536 20.0607 21.9393C20.6464 22.5251 20.6464 23.4749 20.0607 24.0607L18.6213 25.5L29 25.5C29.8284 25.5 30.5 26.1716 30.5 27C30.5 27.8284 29.8284 28.5 29 28.5L18.6213 28.5L20.0607 29.9393C20.6464 30.5251 20.6464 31.4749 20.0607 32.0607C19.4749 32.6464 18.5251 32.6464 17.9393 32.0607L13.9393 28.0607ZM13.5 17C13.5 16.1716 14.1716 15.5 15 15.5L25.3787 15.5L23.9393 14.0607C23.3536 13.4749 23.3536 12.5251 23.9393 11.9393C24.5251 11.3536 25.4749 11.3536 26.0607 11.9393L30.0607 15.9393C30.6464 16.5251 30.6464 17.4749 30.0607 18.0607L26.0607 22.0607C25.4749 22.6464 24.5251 22.6464 23.9393 22.0607C23.3536 21.4749 23.3536 20.5251 23.9393 19.9393L25.3787 18.5L15 18.5C14.1716 18.5 13.5 17.8284 13.5 17Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokTapConvert);
export default __webpack_public_path__ + "static/media/tiktok_tap_convert.c2f38e83e6465e38891e9954169b874c.svg";
export { ForwardRef as ReactComponent };